import React, { useContext, useState, useEffect, useCallback } from 'react';

import { fetchSectors, fetchEndpoints, exportSelectAllEndpoints } from '../../services/api';
import { accessLocalStorage } from '../../services';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

  const FilterReportsCalls = ({ sendFilterDashboard, readingDb }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints,setEndpoints, verifySort, dataForRequestCalls, setDataForRequestCalls, setStorageDataReport } = getItensStateGlobal;

  const { initDate, endDate, getStatus, getType } = dataForRequestCalls;

  const [values, setValues] = useState({});
  const [sectorsDb, setSectorsDb] = useState([]);
  const [localEndpoints, setLocalEndpoints] = useState([]);

  const handleChangeValues = (item) => {
    const { name, value } = item;
    
    // const itemStatus = handleChangeDataAnalyze(name, value);
    // setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    // if(Object.keys(validate).length >= 13) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;

  };

  
  const getAllEndpointsConfig = async () => {
    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) return setLoading(true);
    const elements = endpointsList.reduce((acc, cur) => {
      // acc[`${cur.endpoint}`] = cur.callerid.split(' ')[0];
      const getNameEndpoint = cur.callerid.split(' ');
      acc[`${cur.endpoint}`] = getNameEndpoint.length > 2 ? `${cur.callerid.split(' ')[0]} ${cur.callerid.split(' ')[1]}` : cur.callerid.split(' ')[0];
      return acc;
    },{})
    return elements;
  };
  
  const getApiEndpoints = useCallback(async () => {
    const endpointsFetcheds = await fetchEndpoints();
    const endpointsConfig = await getAllEndpointsConfig();

    const endpointsReceived = endpointsFetcheds.map((element) => {
      !isNaN(Number(element.resource)) ? element['name'] = endpointsConfig[`${element.resource}`] : element.resource;
      return element;
    });

    if (endpointsReceived) {
      // setLoading(false);

      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let { user: { endpointsviewer }} = dataUser;
      const visibility = endpointsviewer !== 'all' ? endpointsviewer.split(',') : [];
      
      const endpointsForViewer = visibility.length > 0 ? endpointsReceived.filter((endpoint) => {
        if(visibility.includes(endpoint.resource)) return endpoint;
      }) : endpointsReceived;
      setEndpoints(endpointsForViewer);
      
      return;
    }
  }, []);

  const fetchQueuesAndEndpoints = useCallback(async () => { 
    const getSectorsInDb = await fetchSectors();
    const edtSectors = getSectorsInDb ? getSectorsInDb.map((s) => s.sector) : [];

    const localFetchEndpoints = await getApiEndpoints();

    // const localFetchEndpoints = await fetchEndpoints();

    // const endpointsReceived = localFetchEndpoints.map((element) => {
    //   !isNaN(Number(element.resource)) ? element['name'] = endpointsConfig[`${element.resource}`] : element.resource;
    //   return element;
    // });
    // const edtEndpoints = endpointsReceived.map((e) => e.resource).filter((e) => !isNaN(e));

    setSectorsDb(edtSectors);
    // setLocalEndpoints(edtEndpoints);
    setValues(dataForRequestCalls);

    return;
  }, [dataForRequestCalls]);

  const rangeHours = Array.from({ length: 24 }).map((_, index) => index.toString());

  useEffect(() => {
    fetchQueuesAndEndpoints();
  }, [fetchQueuesAndEndpoints]);

  return (
    <div>
      <div className="columns mt-1 mb-0">
        <div className="column is-three-fifths is-offset-one-fifth">
          <div className="control">
            <h1 className="is-size-4 has-text-centered has-text-weight-bold">Filtro de Chamadas</h1>
          </div>
        </div>
      </div>
      <form onSubmit={ (e) =>  e.preventDefault() }>
        <div className="columns mx-2">
          <div className="column is-2 is-offset-4 field">
            <label className="label">Data Inicial *
              <div className="control">
              <input className="input" name="initDate" id="date-initial" type="date" defaultValue={ initDate } onChange={(e) => handleChangeValues(e.target)} />
            </div>
            </label>
          </div>
          <div className="field column is-2">
            <label className="label">Data Final *
              <div className="control">
              <input className="input" name="endDate" id="date-final" type="date" defaultValue={ endDate } onChange={(e) => handleChangeValues(e.target)}
              />
            </div>
            </label>
          </div>
        </div>
        <div className="columns mx-2">
          <div className="column is-2">
            <label className="label">Tipo
              <div className="control is-full">
                <div className="select is-full">
                  <select className="select is-full" name="getType" defaultValue={ getType } onChange={ (e) => handleChangeValues(e.target) }>
                    <option className="is-2" value="">Selecione</option>
                    <option value="realizada">Efetuada</option>
                    <option value="recebida">Recebida</option>
                    <option value="interna">Interna</option>
                  </select>
                </div>
              </div>
            </label>
          </div>
          <div className="column">
            <label className="label">Setor
              <div className="control">
                <div className="select pl-0">
                  <select name="sector" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    { 
                      sectorsDb.sort(verifySort).map((s, i) => <option key={ i } value={ s }>{ s }</option>)
                    }
                  </select>
                </div>
              </div>
            </label>
          </div>
          <div className="column">
            <label className="label">Ramal
              <div className="control">
                <div className="select">
                  <select className="select" name="getEndpoint" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    { 
                      endpoints.sort((a, b) => a - b).map((endpoint, index) => <option key={ index } value={ endpoint.resource }>{ endpoint.name }</option>)
                    }
                  </select>
                </div>
              </div>
            </label>
          </div>
          <div className="column">
            <label className="label">Hora Inicial
              <div className="control">
                <div className="select">
                  <select className="select" name="initHour" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    { 
                      rangeHours.map((hour, index) => <option key={ index } value={ `${hour.padStart(2, '0')}:00:00` }>{ hour }</option>)
                    }
                  </select>
                </div>
              </div>
            </label>
          </div>
          <div className="column">
            <label className="label">Hora Final
              <div className="control">
                <div className="select">
                  <select className="select" name="endHour" onChange={(e) => handleChangeValues(e.target)}>
                    <option value="">Selecione</option>
                    { 
                      rangeHours.map((hour, index) => <option key={ index } value={ `${hour.padStart(2, '0')}:59:59` }>{ hour }</option>)
                    }
                  </select>
                </div>
              </div>
            </label>
          </div>
          <div className="field column">
            <label className="label">Protocolo
              <div className="control">
                <input
                  className="input"
                  name="getProtocol"
                  type="text"
                  placeholder="Digite do prot."
                  onChange={ (e) => handleChangeValues(e.target) }
                />
              </div>
            </label>
          </div>
          <div className="field column">
            <label className="label">Telefone
              <div className="control">
                <input
                  className="input"
                  name="telNumber"
                  type="text"
                  placeholder="Apenas números"
                  onChange={ (e) => handleChangeValues(e.target) } />
              </div>
            </label>
          </div>
        </div>
        <div className={`columns is-centered mx-2 ${!readingDb ? 'is-active' : 'is-hidden'}`}>
          <div className="field column is-one-quarter">
            <div className="control">
              <button className="button is-info is-fullwidth px-1" type="submit" onClick={ () => sendFilterDashboard(values) }>
                <span className="icon">
                  <FontAwesomeIcon icon={faFilter} fixedWidth />
                </span>
                <span>
                  FILTRAR
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className={`columns is-centered mx-2 ${readingDb ? 'is-active' : 'is-hidden'}`}>
          <div className="field column is-one-quarter">
            <div className="control">
              <button className="button is-info is-fullwidth px-1 is-loading"/>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FilterReportsCalls;
